module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/122.b04d6910.png";